<template>
  <div class="navigation-container flex absolute bottom-0 w-full">
    <ul class="flex navigation container mx-auto font-bold text-lg?">
      <router-link :class="linkTextColor" class="mx-auto cursor-pointer" :to="{name: 'QuickMenu'}">BACK TO START</router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  props:{
    textColor:{
      required: false,
      type: String,
      default: 'black'
    }
  },
  computed: {
  linkTextColor: function () {
    return {
      'text-black': this.textColor == 'black',
      'text-white': this.textColor == 'white',
    }
  }
 }
}
</script>

<style lang="css" scoped>

@media (min-width: 1367px){
  .navigation-container{
    height: 3rem;
    /* margin-bottom: 1.5rem; */
  }
}

</style>
